import { Action } from 'redux';
import { InvoicesApisActionTypes } from './constants';

export type InvoicesApisActionType = {
    type:
        | InvoicesApisActionTypes.GET_INVOICES_APIS_DATA
        | InvoicesApisActionTypes.INVOICES_API_RESPONSE_SUCCESS
        | InvoicesApisActionTypes.INVOICES_API_RESPONSE_ERROR;
    payload:
        | {}
        | string
        | {
              franchiseId?: string;
              year?: string | number;
              month?: string | number;
          };
};

export const invoicesApiResponseSuccess = (actionType: string, data: any): InvoicesApisActionType => ({
    type: InvoicesApisActionTypes.INVOICES_API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const invoicesApiResponseError = (actionType: string, error: any): InvoicesApisActionType => ({
    type: InvoicesApisActionTypes.INVOICES_API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getInvoicesApis = (filters?: {
    franchiseId?: string;
    year?: string | number;
    month?: string | number;
}): InvoicesApisActionType => ({
    type: InvoicesApisActionTypes.GET_INVOICES_APIS_DATA,
    payload: filters || {},
});
